import { RoleDomainModel } from '@shared/models/backend'
import { getRole } from '@shared/utils/degts-utils'

export interface MenuItemConfig {
  label: string
  roles: RoleDomainModel[]
  icon?: string
  to?: string
}

/* TODO atualizar itens para outras versões */
export const MENU_ITEMS: MenuItemConfig[] = [
  {
    label: 'Trocar acesso',
    to: '/login/acesso',
    roles: [getRole('ROLE_COORDENADOR'), getRole('ROLE_SUPERVISOR')],
  },
  {
    label: 'Editar perfil',
    to: '/usuario/editarPerfil',
    roles: [getRole('ROLE_COORDENADOR'), getRole('ROLE_SUPERVISOR')],
  },
  {
    label: 'Alterar senha',
    to: '/usuario/alterarSenha',
    roles: [
      getRole('ROLE_COORDENADOR'),
      getRole('ROLE_DEGTS'),
      getRole('ROLE_SUPERVISOR'),
      getRole('ROLE_FINANCEIRO'),
      getRole('ROLE_TRANSFERENCIA'),
      getRole('ROLE_RESIDENTE'),
      getRole('ROLE_ADMINISTRADOR'),
    ],
  },
]
